// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__X18f8","overlay":"Modal_overlay__W5iqx","content":"Modal_content__sOEFG","opened":"Modal_opened__ParjW","isClosing":"Modal_isClosing__e-Frd"};